import React from 'react'
import constantes from '../../constantes/constantes'
import Text from '../../shared/textStyleDefault/texto'

const listaBeneficios = constantes.beneficios

const Beneficios: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:flex max-w-full mx-auto gap-10">
      {listaBeneficios.map((beneficio) => (
        <div
          key={beneficio.icono}
          className="flex flex-col items-center lg:items-start text-start min-w-[260px] max-w-[270px] gap-6 flex-1"
        >
          <img src={beneficio.icono} alt="icono" className="w-16 h-16" />
          <div className="flex flex-col gap-4 w-full">
            <Text variant="beneficiosTitulo" className="mb-2">
              {beneficio.titulo}
            </Text>
            <Text as="p" variant="beneficiosParrafo">
              {beneficio.texto}
            </Text>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Beneficios
